import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { DealerBusinessService } from '../../../business-services/dealer.service';
import { CultureLocaleService } from '../../../services/culture-locale.service';
import { Country, LocationCode } from './../../../business-entities/country.model';
import { DealerDetailsListViewModel } from './../../../business-entities/dealer-details-view-model';
import { DealerConfigurationWaitingTime, DealerViewModel } from './../../../business-entities/dealer-view-model';
import { CityModel } from '../../../business-entities/customer-view.model';
import { CustomerService } from '../../../business-services/customer.service';
import { ToNumberPipe } from '../../../pipe/toNumber.pipe';
import { DecimalPipe } from '@angular/common';
import { Features } from '../../../business-entities/user-role-view-model';
import { RolesRightsService } from '../../../business-services/roles-rights.service';
import * as Enums from "projects/Autofacets-Core/src/app/utils/enums";
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { OlbDealerViewModel } from '../../../business-entities/olb-dealer.model';
import { CountryISO } from 'ngx-intl-tel-input-gg';
import { SettingService } from '../../../business-services/setting.service';

@Component({
  selector: 'app-add-dealer',
  templateUrl: './add-dealer.component.html',
  styleUrls: ['./add-dealer.component.css']
})


export class AddDealerComponent implements OnInit, OnDestroy {

  addDealerForm: FormGroup;
  dealerDetailsListViewModel: DealerDetailsListViewModel;
  dealerDetails: DealerViewModel;
  countryDropdown: Country[] = [];
  locationDropdown: LocationCode[] = [];
  userInputMobilecode?: string = '';
  userInputLandlinecode?: string = '';
  isUnitPriceLengthError: boolean = false;
  isValidUnitPrice: boolean = false;
  postCodeList: any;
  postCodeRawData: any;
  cityList: CityModel[];
  countryName: string;
  countryId: number;
  countryList: any;
  isFormValid: boolean = false;
  features: Features[] = [];
  isShareBoxEnabled: boolean = false;
  showDealerSession: boolean = false;
  isDealerSessionIdError: boolean = false;
  isPickUpDropOff: boolean = false;
  isShowPriceInBrand: boolean = false;
  isShowLocationCode : boolean = false;
  @Input() olbDealer: OlbDealerViewModel;
  isMg: boolean = false;
  deliveryTimeSlot: any = { hour: 0, minute: 0 };
  configurationArrivalTimes: DealerConfigurationWaitingTime[] = [];
  configurationWaitingTimes: DealerConfigurationWaitingTime[] = [];
  CountryISO = CountryISO;
  isInitialLoad: boolean= true;
  isInitialLoadLandline: boolean= true;
  onlyCountries: string[] = [];
  countryDialCodes: any[]= [];
  selectedCountryISOMobile= this.cultureLocaleService.getLocale() || CountryISO.Norway;
  selectedCountryISOLandline= this.cultureLocaleService.getLocale() || CountryISO.Norway;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly dealerBusinessService: DealerBusinessService,
    private readonly toastr: ToastrService,
    private readonly spinner: NgxSpinnerService,
    private readonly globalSetting: GlobalSetting,
    private readonly cultureLocaleService: CultureLocaleService,
    private readonly activeModal: NgbActiveModal,
    private readonly translate: TranslateService,
    private readonly service: CustomerService,
    private readonly decimalPipe: DecimalPipe,
    private readonly rolesRightsService: RolesRightsService,
    private readonly cdr: ChangeDetectorRef,
    private readonly secureStorage: SecureStorage,
    private readonly settingService: SettingService
  ) { }

  ngOnInit(): void {
    this.onlyCountries = this.settingService.onlyCountries;
    this.countryDialCodes = this.settingService.countryDialCodes;
    this.isShowLocationCode = localStorage.getItem("Theme") === 'bnh';
    this.isMg = localStorage.getItem("Theme") === 'mg';
    this.addDealerForm = this.formBuilder.group({
      name: ['', [Validators.required, Validators.pattern(/^(?!\s+$)/)]],
      address1: ['', [Validators.required]],
      address2: [''],
      city: [null, [Validators.required]],
      state: [''],
      country: [-1, [Validators.required, Validators.min(0)]],
      pincode: [null, [Validators.required]],
      landline: ['', [Validators.required]],
      mobile: [''],
      email: ['', [Validators.required, Validators.pattern(Enums.RegexKeyCollection.Email)]],
      isActive: [true],
      keyLocation: [false],
      onlinePayment: [false],
      isActiveForWidget: [true],
      vehiclePickupDropoffService: [false],
      dealershipsId: [0, this.isShowLocationCode ? [Validators.required] : null],
      franchiseId: [null],
      vatNumber: [null, [Validators.required]],
      //adUserId: [null, [Validators.required]],
      unitPrice: ['', [Validators.required]],
      customerWaitingLimit: [0, [Validators.required]],
      bankAccountNumber: ['', [Validators.maxLength(30)]],
      companyNumber: ['', [Validators.required, Validators.maxLength(30)]],
      dealerSessionId: [''],
      enableRentalCar: [false],
      leadTime: [0],
      rentalProvider: [0],
      rentalCarPrice: [0],
      enableDMS: [false],
      enableMenuPricing: [false],
      enableBookingNotification: [false],
      enableWaiting: [false],
      serviceAgreement: [false],
      kiosk: [false],
      realTimeBooking: [false],
      isCampaignPriceConsidered: [false],
      website: [null],
      dealerDmsNo: [null],
      latitude: [0],
      longitude: [0],
      noOfWeekInCalendar: [0],
      dealerDropInLink: ['']
    });

    this.getCountries();
    this.getLocationCode();
    this.telInputObject();
    this.telInputObjectForLandline();
    this.getPostCodeDropdown();
    this.countryDropdownDetails();
    this.getFeatures();
    this.showHideDealerSession();
    this.patchDefaultValue();
    this.patchOlbDealerDetail();
  }
  patchDefaultValue() {
    this.cdr.detectChanges();
    this.addDealerForm.patchValue({
      unitPrice: this.isShowPriceInBrand 
      ? this.decimalPipe.transform(parseFloat('0'), '1.2-2'):
      this.decimalPipe.transform(parseFloat(this.secureStorage.getKeyData('LaborUnitPrice')), '1.2-2'),
    });
    this.cdr.detectChanges();
  }

  telInputObject() {
      if (this.userInputMobilecode) {
        let countryCode = this.getCountryCodeByDialCode(this.userInputMobilecode);
        this.selectedCountryISOMobile= countryCode ? countryCode : this.cultureLocaleService.getLocale();
      }
      else
        this.selectedCountryISOMobile= this.cultureLocaleService.getLocale();
  }

  getCountryCodeByDialCode(dialCode: any) {
    const country = this.countryDialCodes.find(c => c.dialCode === dialCode);
    return country ? country.countryCode : null;
  }

  onCountryChange(obj) {
    if (this.isInitialLoad) {
    this.telInputObject();
    this.userInputMobilecode = this.userInputMobilecode || obj.dialCode;
    this.isInitialLoad = false;
    } else {
      this.userInputMobilecode = obj.dialCode;
    }
  }

  BindPostData(city) {
    if (city?.trim()) {
      this.postCodeList = this.postCodeRawData.filter(f => f.city == city);
      if (this.cpf.pincode.value?.length === 0) {
        this.addDealerForm.patchValue({
          pincode: this.postCodeList[0]?.code
        })
      }
    } else {
      this.postCodeList = this.postCodeRawData;
    }
  }
  async onPostCodeSelected(postCode: string) {
    this.addDealerForm.patchValue({
      pincode: postCode
    })
    if (postCode?.trim()) {
      this.BindCityData(postCode);
      this.BindCountry(postCode)
    } else {
      this.postCodeList = this.postCodeRawData;
      this.addDealerForm.patchValue({
        city: null,
        country: -1
      })
    }
  }
  BindCityData(post) {
    if (post?.trim()) {
      let postdata = this.postCodeRawData.filter(f => f.code == post);
      this.cityList = postdata.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
      this.onCitySelected(this.cityList[0])
    } else {
      this.cityList = this.postCodeRawData.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
    }
  }
  async onCitySelected(city: any) {
    if (city?.trim()) {
      this.BindPostData(city);
      this.BindCountryBasedCity(city);
    } else {
      this.cityList = this.postCodeRawData.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
      this.addDealerForm.patchValue({
        pincode: null,
        city: city,
        country: -1
      })
    }
  }
  BindCountryBasedCity(city) {
    let postdata = this.postCodeRawData.filter(f => f.city == city)
    let countryCode = postdata.map(item => item.countryCode).filter((value, index, self) => self.indexOf(value) === index);
    let selectedCountry = this.countryList.filter(f => f.code === countryCode[0])
    this.countryName = selectedCountry[0]?.countryName;
    this.countryId = selectedCountry[0]?.id;
  }
  async getPostCodeDropdown() {
    this.spinner.show();
    let postCodes = this.secureStorage.getKeyData('postCodes');
    if (postCodes) {
      this.postCodeRawData = postCodes;
      this.BindPostData("");
      this.BindCityData("");
    } 
    this.spinner.hide();
  }
  BindCountry(postCode) {
    let postdata = this.postCodeRawData.filter(f => f.code == postCode);
    let countryCode = postdata.map(item => item.countryCode).filter((value, index, self) => self.indexOf(value) === index);
    let selectedCountry = this.countryList.filter(f => f.code === countryCode[0]);
    this.countryId = (selectedCountry[0]?.id) != undefined ? selectedCountry[0]?.id : 0;
  }
  async countryDropdownDetails(): Promise<void> {
    await this.service.getCountryCodeAndMobileCodeDetails()
      .then((response) => {
        this.countryList = response?.responseObject?.result.filter(x => x.isDisplay);
      }, _error => {
        this.spinner.hide();
      });
  }

  checkLength(event): void {
    if (event.target.value) {
      let inputValue = event.target.value.toString().trim().replace(/^0+/, '');
      if (inputValue.toString().includes(',') || /\s/.test(inputValue)) {
        if (inputValue.split(",").length - 1 > 1) {
          this.isValidUnitPrice = true;
        }
        else if (inputValue.toString().includes('.') && inputValue.toString().includes(',')) {
          this.isValidUnitPrice = true;
        }
        else {
          this.isValidUnitPrice = false;
          let splitedValue = inputValue.toString().split(',');
          let val = splitedValue[0].replace(/\s/g, '');
          this.isUnitPriceLengthError = val.length > 6 ? true : false;
        }
      } else if (inputValue.toString().includes('.')) {
        if (inputValue.split(".").length - 1 > 1) {
          this.isValidUnitPrice = true;
        }
        else if (inputValue.toString().includes('.') && inputValue.toString().includes(',')) {
          this.isValidUnitPrice = true;
        }
        else {
          this.isValidUnitPrice = false;
          let splitedValue = inputValue.toString().split('.');
          let val = splitedValue[0].replace(/\s/g, '');
          this.isUnitPriceLengthError = val.length > 6 ? true : false;
        }
      }
      else {
        this.isValidUnitPrice = false;
        this.isUnitPriceLengthError = inputValue.length > 6 ? true : false;
      }

    }
  }

  telInputObjectForLandline() {
      if (this.userInputLandlinecode) {
        let countryCode = this.getCountryCodeByDialCode(this.userInputLandlinecode);
        this.selectedCountryISOLandline= countryCode ? countryCode : this.cultureLocaleService.getLocale();
      }
      else
        this.selectedCountryISOLandline= this.cultureLocaleService.getLocale();
  }

  onCountryChangeForLandline(obj) {
    if (this.isInitialLoadLandline) {
    this.telInputObjectForLandline();
    this.userInputLandlinecode = this.userInputLandlinecode || obj.dialCode;
    this.isInitialLoadLandline = false;
    } else {
      this.userInputLandlinecode = obj.dialCode;
    }
  }


  get cpf() {
    return this.addDealerForm.controls;
  }

  async getCountries() {
    this.countryDropdown = await this.dealerBusinessService.getAllCountries();
  }

  async getLocationCode() {
    this.locationDropdown = await this.dealerBusinessService.getLocationCode();
  }

  onChangeUnitPrice(event) {
    const toNumberPipe = new ToNumberPipe();
    const formatted = this.decimalPipe.transform(toNumberPipe.transform(event.target.value), '1.2-2');
    this.addDealerForm.patchValue({ unitPrice: formatted });
  }

  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }

  onSubmit(): void {
    if (this.addDealerForm.invalid) {
      this.isFormValid = false;
      return;
    }
    this.isFormValid = true;
    this.addDealerForm.controls.landline= this.addDealerForm.controls.landline.value?.number ? this.addDealerForm.controls.landline.value.number.toString().replace(/\s+/g, '') : this.addDealerForm.controls.landline.value;
    this.addDealerForm.controls.mobile= this.addDealerForm.controls.mobile.value?.number ? this.addDealerForm.controls.mobile.value.number.toString().replace(/\s+/g, '') : this.addDealerForm.controls.mobile.value;
    let viewModel = {
      ...this.addDealerForm.value,
      franchiseId: Number(this.addDealerForm.value.franchiseId),
      email: this.cpf.email.value.toString().toLowerCase(),
      mobileCode: this.addDealerForm.value.mobile != "" ? this.userInputMobilecode : "",
      landlineCode: this.addDealerForm.value.landline != "" ? this.userInputLandlinecode : "",
      name: this.addDealerForm.value.name.trim()
    };
    viewModel.configurationArrivalTimes = this.configurationArrivalTimes;
    viewModel.configurationWaitingTimes = this.configurationWaitingTimes;
    viewModel.unitPrice = this.globalSetting.getFormattedprice(this.addDealerForm.value.unitPrice.trim());
    this.spinner.show();
    let userLimitError = this.translate.instant('lblDealerCreationLimitExceed');
    this.dealerBusinessService.addDealer(viewModel).then((response) => {
      this.spinner.hide();
      let result = response.responseObject;
      if (result) {
        if (result.errorCount && result.errorCount > 0) {
          let errorResponse = result.result;
          if (errorResponse.errorCode == Enums.ErrorCodes.AlreadyExist) {
            let errorMessage = this.translate.instant(errorResponse.errorMessage);
            this.toastr.error(errorMessage);
          }
          else if (errorResponse.errorCode == Enums.ErrorCodes.UserCreationLimitExceed) {
            this.toastr.error(userLimitError);
          }
        } else {
          this.toastr.success(Enums.ToastrMessages.DealerAdded);
        }
      } else {
        this.toastr.error(Enums.ToastrMessages.DealerAddedFailed);
      }
    });
  }

  async getFeatures() {
    this.rolesRightsService.getFeatures().then((res) => {
      if (res.responseObject.errorCount === 0) {
        this.features = res.responseObject.result;
      }
      if (this.features && this.features.length > 0) {
        this.isShowPriceInBrand = this.features.find(x => x.featureCode === Enums.FeatureCode.AllowDealerBrandLaborRate)?.isActive;
        this.isShareBoxEnabled = this.features.find(x => x.featureCode === Enums.FeatureCode.ShareBox)?.isActive;
        this.isPickUpDropOff = this.features.find(x => x.featureCode === Enums.FeatureCode.PickupDropoff)?.isActive;
      }
    })
  }

  showHideDealerSession() {
    this.showDealerSession = false;
    if (this.cpf.keyLocation.value && this.isShareBoxEnabled) {
      this.showDealerSession = true;
      this.addDealerForm.get('dealerSessionId').setValidators([Validators.required]);
      this.addDealerForm.get('dealerDropInLink').setValidators([Validators.required]);
    }
    else if (!this.cpf.keyLocation.value && this.isShareBoxEnabled) {
      this.isDealerSessionIdError = false;
      this.addDealerForm.get('dealerSessionId').reset();
      this.addDealerForm.get('dealerSessionId').setErrors(null);
      this.addDealerForm.get('dealerDropInLink').reset();
      this.addDealerForm.get('dealerDropInLink').setErrors(null);
    }
  }

  validateDealerSessionId() {
    this.isDealerSessionIdError = false;
    // if (this.cpf.dealerSessionId != null) {
    //   let regexp = /'^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$'/;
    //   let testId = regexp.test(this.cpf.dealerSessionId.value.toString());
    //   this.isDealerSessionIdError = testId ? false : true;
    // }
  }
  OnClose() {
    this.isFormValid = false;
    this.activeModal.close({ success: true });
  }
  ngOnDestroy(): void {
    this.olbDealer = undefined;
  }
  patchOlbDealerDetail() {
    if (localStorage.getItem('Theme') == 'mg' && this.olbDealer) {
      this.OlbGetDealerDetail(this.olbDealer.dealerDMSNo);
      this.OlbGetDealerConfig(this.olbDealer.dealerDMSNo);
    }
  }

  async OlbGetDealerDetail(dealerDmsNo) {
    this.spinner.show();
    await this.dealerBusinessService.OlbGetDealerDetail(dealerDmsNo).then((response) => {
      if (response) {
        const countryCode = response.countryCode.replace('+','');
        const country = this.countryList.find(x => x.mobileCode == response.countryCode);
        response.countryCode = country ? country.id : -1;

        this.addDealerForm.patchValue({
          name: response.name,
          address1: response.address,
          city: response.city,
          state: response.county,
          country: +(response.countryCode),
          mobile: response.phoneNo,
          landline: response.phoneNo,
          email: response.email,
          isActive: response.isActive,
          isActiveForWidget: response.isOnlineBooking,
          companyNumber: response.companyNo,
          pincode: response.postCode,
          website: response.website,
          dealerDmsNo: response.dealerDMSNo,
          latitude: response.latitude,
          longitude: response.longitude
        });
        if (countryCode !== null && countryCode !== '0') {
          this.userInputMobilecode = countryCode;
          this.userInputLandlinecode = countryCode;
        }
        this.telInputObject();
        this.telInputObjectForLandline();

        this.addDealerForm.get('companyNumber').reset();
        this.addDealerForm.get('vatNumber').reset();
        this.addDealerForm.get('companyNumber').setErrors(null);
        this.addDealerForm.get('vatNumber').setErrors(null);
      }
    }).finally(() => {
      this.spinner.hide();
    });
  }
  async OlbGetDealerConfig(dealerDmsNo) {
    this.spinner.show();
    await this.dealerBusinessService.OlbGetDealerConfig(dealerDmsNo).then((response) => {
      if (response) {
        this.addDealerForm.patchValue({
          isActiveForWidget: response.enableOnlineBooking,
          customerWaitingLimit: response.waitingCapacity,
          enableDMS: response.enableDMS,
          enableMenuPricing: response.enableMenuPricing,
          enableBookingNotification: response.enableBookingNotification,
          enableWaiting: response.enableWaiting,
          leadTime: response.leadTime,
          serviceAgreement: response.serviceAgreement,
          kiosk: response.kiosk,
          realTimeBooking: response.realTimeBooking,
          isCampaignPriceConsidered: response.isCampaignPriceConsidered,
          enableRentalCar: response.enableRentalCar,
          rentalProvider: response.rentalProvider,
          rentalCarPrice: response.rentalCarPrice,
          noOfWeekInCalendar: response.noOfWeekInCalendar
        });
        this.configurationArrivalTimes = this.sortTimeSlots(response.configurationArrivalTimes) ?? [];
        this.configurationWaitingTimes = this.sortTimeSlots(response.configurationWaitingTimes) ?? [];
      }
    }).finally(() => {
      this.spinner.hide();
    });
  }
  onTimeSlotAdd() {
    if (this.deliveryTimeSlot && (this.deliveryTimeSlot.hour > 0 || this.deliveryTimeSlot.minute > 0)) {
      const timeSlotString =  (this.deliveryTimeSlot.hour < 10 ? '0' : '') + this.deliveryTimeSlot.hour.toString() + ':' + (this.deliveryTimeSlot.minute < 10 ? '0' : '') + this.deliveryTimeSlot.minute.toString();
      let duplicateRecordIndex = this.configurationArrivalTimes?.findIndex(x => x.timeSlot === timeSlotString);
      if (duplicateRecordIndex < 0) {
        let timeSlotDetail: DealerConfigurationWaitingTime = {
          dealerId : null,
          timeSlot : timeSlotString,
          timeSlotId: 0,
          timeSlotType: 2
        }
        this.configurationArrivalTimes.push(timeSlotDetail);
        this.configurationArrivalTimes = this.sortTimeSlots(this.configurationArrivalTimes);
      }
    }
  }  

  onTimeSlotDelete(timeSlot) {
    this.configurationArrivalTimes = this.configurationArrivalTimes?.filter(x => x.timeSlot !== timeSlot);
  }

  sortTimeSlots(slots: DealerConfigurationWaitingTime[]): DealerConfigurationWaitingTime[] {
    return slots?.sort((a, b) => {
      const timeA = new Date(`1970-01-01T${a.timeSlot}:00`);
      const timeB = new Date(`1970-01-01T${b.timeSlot}:00`);
      return timeA.getTime() - timeB.getTime();
    });
  }
  onMobileChange(){
    if(this.addDealerForm.get('mobile').value){
      let len= this.addDealerForm.get('mobile').value.number.toString().replace(/\s+/g, '').length;
      if(len<6 || len>11){
        this.addDealerForm.get('mobile').setValidators([Validators.pattern(/^\d{6,11}$/)]);
        this.addDealerForm.get('mobile').updateValueAndValidity();
      } else {
        this.addDealerForm.get('mobile').setValidators([]);
        this.addDealerForm.get('mobile').updateValueAndValidity();
      }
    }
  }
  onLandlineChange(){
    if(this.addDealerForm.get('landline').value){
      let len= this.addDealerForm.get('landline').value.number.toString().replace(/\s+/g, '').length;
      if(len<6 || len>11){
        this.addDealerForm.get('landline').setValidators([Validators.required, Validators.pattern(/^\d{6,11}$/)]);
        this.addDealerForm.get('landline').updateValueAndValidity();
      } else {
        this.addDealerForm.get('landline').setValidators([Validators.required]);
        this.addDealerForm.get('landline').updateValueAndValidity();
      }
    }
  }
}
